<div class="SLV2-bookmrk-sbjct-popup">
    <button class="SLV2-popup-close-btn" (click)="close()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
    </button>
    <h5 class="SLV2-bookmrk-pop-title">Subjects</h5>

    <ul class="SLV2-bookmrk-chk-list">
        <li *ngFor="let item of data.dialogSection; let i = index">
            <label>
                <input type="checkbox" name="subject" [checked]="isSelected(item.nodeId)"  id={{item.nodeId}} (change)="onSubjectChange($event,item)" />
                <span>{{item.nodeName}}</span>
            </label>
        </li>
    </ul>  
    
    
    <div class="SLV2-complete-actn-area">
        <button class="SLV2-complete-text-btn" (click)="cancel()">Cancel</button>
        <button class="SLV2-complete-solid-btn" (click)="close()">Submit</button>
    </div>


</div>




